import { configureStore } from "@reduxjs/toolkit";
import userReducer from "../features/User/UserSlice"
import adminReducer from '../features/Admin/AdminSlice'
import booksReducer from '../features/Books/BooksSlice'

import { combineReducers } from 'redux'

import storage from "redux-persist/lib/storage"
import { persistReducer, persistStore } from 'redux-persist';
import {
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist'

const persistConfig = {
    key: 'root',
    storage,
}
const rootReducer = combineReducers({ BookWormUser: userReducer, BookWormAdmin: adminReducer ,Books : booksReducer});

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            }
        })
})


export const persistor = persistStore(store)